export default __webpack_public_path__ + "5edd3b9618887f3978692de1185101fb.png";